<div class="scope-row items-center">
  <div
    class="scope-row-content flex items-center"
    (click)="selectSection(section.id)">
    <div
      class="column level-{{ level }} flex items-center"
      [ngClass]="config?.componentMainColumnClass">
      <mat-icon
        class="material-symbols-rounded arrow orange"
        [class.active]="scopeElementsService.deliverableSectionStates.selected[section.id]">
        expand_more
      </mat-icon>
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="section"
        c-key="name"
        c-type="section">
        {{ section.name }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()"></div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.QUANTITY?.selected"></div>
    <div
      class="column one--column"
      [hidden]="!isPreferenceActive(config?.userColumns.START_DATE)">
      <span>{{ section.startDate || deliverable.startDate | dateFormat: 'shortDate' }}</span>
    </div>
    <div
      class="column one--column"
      [hidden]="!isPreferenceActive(config?.userColumns.END_DATE)">
      <span>{{ section.endDate || deliverable.endDate | dateFormat: 'shortDate' }}</span>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.MARK_UP?.selected"></div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="section"
        [c-key]="'tpcValue'"
        [c-type]="'section'">
        {{ section.calculateThirdPartyCosts(deliverable)?.amount | convertCurrency: config?.currency }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_HOURS?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="section"
        [c-key]="'rateCardHours'"
        [c-type]="'section'">
        {{ section.getTotalScopeMarkHours(deliverable) | formatHours }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.SCOPEMARK_PRICE?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="section"
        [c-key]="'scopeMarkSellingPrice'"
        [c-type]="'section'"
        [has-privilege]="Privilege.SCOPE__VIEW_RATES"
        [has-privilege-mask]="DEFAULT_PLACEHOLDER"
        [has-setting]="ApplicationSetting.RATECARD__SCOPEMARK__RATES"
        [has-setting-disabled-mask]="DEFAULT_PLACEHOLDER">
        {{ section.totalScopeMarkSellingPrice(deliverable)?.amount | convertCurrency: config?.currency }}
      </commentable>
    </div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_HOURS?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="section"
        [c-key]="'rateCardHours'"
        [c-type]="'section'">
        {{ section.getTotalRateCardHours(deliverable) | formatHours }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.userColumns.UNIT_PRICE?.selected"></div>
    <div
      class="column one--column"
      [hidden]="config?.isTimeline || !config?.scopeVersion.isScopeByScenario()"></div>
    <div
      class="column {{ config?.isTimeline ? 'three--columns' : 'one--column' }}"
      [hidden]="!config?.isTimeline && !config?.userColumns.AGENCY_PRICE?.selected">
      <commentable
        [c-root-entity]="deliverable"
        [c-entity]="section"
        [c-key]="'agencySellingPrice'"
        [c-type]="'section'"
        [has-privilege]="Privilege.SCOPE__VIEW_RATES"
        [has-privilege-mask]="DEFAULT_PLACEHOLDER">
        {{ section.getTotalSellingPrice({}, deliverable)?.amount | convertCurrency: config?.currency }}
      </commentable>
    </div>
    <div
      class="column one--column"
      [hidden]="!config?.showActionsColumn"></div>
  </div>
</div>

<ng-container *ngIf="scopeElementsService.deliverableSectionStates.selected[section.id]">
  <scope-components
    [level]="level + 1"
    [config]="config"
    [deliverable]="deliverable"
    [components]="components"
    [feeMenuOptions]="feeMenuOptions"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onOverrideQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
    (onUpdateComponentFee)="onUpdateFeeItem.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)">
  </scope-components>

  <scope-third-party-costs
    *ngIf="section.thirdPartyCosts?.length && !config?.isTimeline"
    [parent]="section"
    [level]="level + 1"
    [config]="config"
    [columns]="getTpcColumns()"
    (onUpdateTpc)="updateDeliverableSectionTpc($event)"
    (onReorderTpcs)="reorderDeliverableSectionTpcs($event)">
  </scope-third-party-costs>
</ng-container>
